import * as React from "react";
const SvgFiRrPayroll = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-payroll_svg__a)">
      <path
        fill="#062147"
        d="M22.46 9.047 22 8.606V8c0-2.206-1.794-4-4-4H6C3.794 4 2 5.794 2 8v.61l-.458.438a5.03 5.03 0 0 0-1.54 3.61v6.341a4.96 4.96 0 0 0 1.463 3.536A4.97 4.97 0 0 0 5.001 24H19c2.757 0 5-2.243 5-5v-6.343a5.03 5.03 0 0 0-1.54-3.61M6 6h12c1.103 0 2 .897 2 2v3.242l-5.879 5.879c-1.133 1.133-3.109 1.133-4.242 0L4 11.242V8c0-1.103.897-2 2-2m16 13c0 1.654-1.346 3-3 3H5.001a2.98 2.98 0 0 1-2.122-.879 2.98 2.98 0 0 1-.878-2.122v-6.341c0-.179.024-.357.055-.531l6.408 6.408A4.97 4.97 0 0 0 11.999 20a4.97 4.97 0 0 0 3.535-1.465l6.41-6.41c.032.175.055.353.055.532zM5 1a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1m11 7.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5-.67 1.5-1.5 1.5S16 9.33 16 8.5M12 16c1.93 0 3.5-1.57 3.5-3.5S13.93 9 12 9s-3.5 1.57-3.5 3.5S10.07 16 12 16m0-5c.827 0 1.5.673 1.5 1.5S12.827 14 12 14s-1.5-.673-1.5-1.5.673-1.5 1.5-1.5M5 8.5C5 7.67 5.67 7 6.5 7S8 7.67 8 8.5 7.33 10 6.5 10 5 9.33 5 8.5"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-payroll_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPayroll;
